
























import Vue from 'vue'
import Component from 'vue-class-component'

import {EdgNavbar} from '@aedifica/ui-components'
import {Inject} from 'vue-property-decorator'
import LoginService from '@/account/login.service'
import AccountService from '@/account/account.service'

@Component({
  name: 'sad-navbar',
  components: {
    EdgNavbar
  }
})
export default class SadNavbar extends Vue {
  @Inject('loginService') private loginService: () => LoginService
  @Inject('accountService') private accountService: () => AccountService

  login(): void {
    this.loginService().loginIhm()
  }

  logout(): void {
    this.loginService().logout()
  }

  get userConnecte() {
    const connectedUser = this.accountService().connectedUser

    if (!connectedUser) {
      return null
    }

    return connectedUser
  }

  get userConnecteNomPrenom() {
    return this.userConnecte ? `${this.userConnecte.prenom} ${this.userConnecte.nom}` : ''
  }

  get isUserLogged() {
    return this.accountService().authenticated
  }

  mounted() {
    Promise.all([this.accountService().isAuthorizedToIHM(), this.accountService().isAuthorizedToPTDDT()]).then(() => {
      if (this.$store.getters.mustLogOntoPtddt) {
        // En cas d'authentification sur l'IHM, et pas sur le portail, on ouvre automatiquement la demande d'autorisation
        // puisque il s'agit de deux ressources différentes (Client OIDC SADCONS = IHM, Client OIDC DATACHAIN = PTDDT)
        this.loginService().loginPtddt()
      }
      if (this.$store.getters.mustLogOntoIhm) {
        // En cas d'authentification sur le portail, et pas sur l'IHM, on ouvre automatiquement la demande d'autorisation
        // puisque il s'agit de deux ressources différentes (Client OIDC SADCONS = IHM, Client OIDC DATACHAIN = PTDDT)
        this.loginService().loginIhm()
      }
      if (this.$store.getters.isAuthenticated) {
        this.accountService()
          .retrieveAccount()
          .then(() => {
            if (this.userConnecte && (!this.userConnecte.authorities || !this.userConnecte.authorities.length)) {
              this.loginService().logout()
              this.$edgToast.showError({
                title: this.$i18n.t('erreur.titre'),
                message: this.$i18n.t('erreur.messageAucunRole')
              })
            }
          })
      }
    })
  }
}
